import React, { FC } from 'react'

interface AnswerItemProps {
  newFiles?: string[]
  value?: string
}

export const AnswerItem: FC<AnswerItemProps> = ({ newFiles, value }) => {
  return (
    <div className="w-full">
      <p className="text-SeabiscuitDark200ThemeColor/50">{value || 'No answer'}</p>
      {newFiles?.[0] && (
        <div className="flex gap-3 flex-wrap pt-5">
          {newFiles.map((file, index) => (
            <a
              key={index}
              href={file}
              rel="noreferrer"
              target="_blank"
              className="w-[45px] h-[45px] bg-[#D3DAEE] rounded-lg hover:opacity-70 transition-opacity"
            >
              <img className="w-full h-full object-cover rounded-lg" src={file} alt="" />
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
